<img src="{{ path }}" alt="hearhub logo" class="hearhub-logo" />
